import React, { useState } from 'react';
import logo from '../assets/logo.svg';
import { trackLanguageSwitch, trackButtonClick } from '../utils/analytics';

const Nav = () => {
  const [opened, setOpened] = useState(true);

  return (
    <div className='w-100'>
      <div className='container'>
        <header className='flex jcsb aic h-10 py-5'>
          <h1 id='logo'>
            <a href='/' aria-label='Logo'>
              <img src={logo} width={128} height={48} alt='c4u' />
            </a>
          </h1>
          <div
            className={opened ? 'burger' : 'burger open'}
            onClick={() => setOpened(!opened)}
          >
            <span className='tt'></span>
            <span className='mm'></span>
            <span className='bb'></span>
          </div>
          <div className={opened ? 'menu active' : 'menu'}>
            <a
              href='#about'
              className='mx-3 px-1'
              onClick={() => setOpened(!opened)}
            >
              About Courses
            </a>
            <a
              href='#offer'
              className='mx-3 px-1'
              onClick={() => setOpened(!opened)}
            >
              Program
            </a>
            <a
              href='#cta'
              className='mx-3 px-1'
              onClick={() => setOpened(!opened)}
            >
              Choose Track
            </a>
            <a
              href='#contact'
              className='mx-3 px-1'
              onClick={() => setOpened(!opened)}
            >
              Contact
            </a>
            <a
              href='/de'
              className='mx-3 px-1'
              onClick={() => {
                setOpened(!opened);
                trackLanguageSwitch('EN', 'DE');
              }}
            >
              DE
            </a>
            <a
              href='#cta'
              className='mx-3 px-1 m-block'
              onClick={() => setOpened(!opened)}
            >
              Sign In
            </a>
          </div>
          <a 
            href='#cta' 
            className='button top m-hide'
            onClick={() => trackButtonClick('Sign In', 'header')}
          >
            Sign In
          </a>
        </header>
      </div>
    </div>
  );
};

export { Nav };
